import React, { useEffect, useRef } from 'react';
import { applyGridColumns, resetGridColumns, startGridResize } from '../utils/gridColumns';

// The grip at the right edge of a table heading: drag to change the width of the column, double-click to put it back.
// (The same grip as in Gennemgang's list, .tabel-resize.) Mounting it also puts the table's remembered widths on the table.
export default function ColGrip() {
  const ref = useRef(null);
  useEffect(() => { applyGridColumns(ref.current); }, []);
  return (
    <span
      ref={ref}
      className="tabel-resize tabel-resize--grid"
      draggable={false}
      title="Træk for at ændre bredden. Dobbeltklik nulstiller."
      onMouseDown={startGridResize}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
      onDoubleClick={resetGridColumns}
    />
  );
}
